import PropTypes from 'prop-types'
import React, { memo, useMemo, useState } from 'react'
import MultiSelectPillList from '../../../../../../components/MultiSelectPillList'

const EMPTY_VALUES = []
const EMPTY_OPTIONS = []

const toTenantOption = (tenantId) => ({ label: tenantId, value: tenantId })

/**
 * Free-entry list of tenant ids. Every id the field has held stays in the dropdown, so one removed
 * by mistake can be picked again instead of retyped. Other props (title, required, ...) go straight
 * to MultiSelectPillList, as the template prompt form labels fields through them.
 */
function PolicyTenantIdsField({ id, onChange, values = EMPTY_VALUES, options = EMPTY_OPTIONS, ...rest }) {
  const tenantIds = values ?? EMPTY_VALUES
  const [knownTenantIds, setKnownTenantIds] = useState(tenantIds)

  const newTenantIds = tenantIds.filter((tenantId) => !knownTenantIds.includes(tenantId))
  if (newTenantIds.length) {
    setKnownTenantIds([...knownTenantIds, ...newTenantIds])
  }

  const tenantOptions = useMemo(() => {
    const optionTenantIds = options.map((option) => option.value)
    return [...new Set([...optionTenantIds, ...knownTenantIds])].map(toTenantOption)
  }, [options, knownTenantIds])

  return (
    <MultiSelectPillList
      {...rest}
      id={id}
      options={tenantOptions}
      onChange={onChange}
      values={tenantIds}
      creatable
      showOptionCheckboxes
    />
  )
}

PolicyTenantIdsField.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })),
  errors: PropTypes.arrayOf(PropTypes.string),
}

export default memo(PolicyTenantIdsField)
